import React, { useState } from "react";
import { useBackground, BACKGROUNDS } from "../BackgroundContext";

export default function BackgroundPicker() {
  const { bgId, setBgId, bg } = useBackground();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)}
        className="flex items-center gap-2 bg-gray-50 hover:bg-gray-100 rounded-lg px-3 py-1.5 text-xs font-bold text-navy">
        <div className="w-4 h-4 rounded border border-gray-200" style={{ background: bg.preview }}></div>
        <span>{bg.name}</span>
        <span className="text-gray-400">▾</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)}></div>
          <div className="absolute top-full right-0 mt-1 bg-white rounded-2xl shadow-xl z-50 p-3 w-64 border border-gray-100">
            <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 px-1">Choose Background</div>
            <div className="grid grid-cols-3 gap-2">
              {BACKGROUNDS.map(b => (
                <button key={b.id} onClick={() => { setBgId(b.id); setOpen(false); }}
                  className={"flex flex-col items-center gap-1 p-2 rounded-xl transition-all " +
                    (bgId === b.id ? "ring-2 ring-mouna-blue" : "hover:bg-gray-50")}>
                  <div className="w-12 h-12 rounded-lg border border-gray-200" style={{ background: b.preview }}></div>
                  <span className="text-xs font-semibold text-navy">{b.name}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
